module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('home-layout', [_c('div', {
    staticClass: "page-bn"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(this.$store.state.guideList.length > 0) ? _c('guide-list', {
    attrs: {
      "guideList": this.$store.state.guideList
    }
  }) : _vm._e(), _vm._v(" "), (this.$store.state.sceneList.length > 0) ? _c('scene-list', {
    attrs: {
      "sceneList": this.$store.state.sceneList
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bfa1500!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/pages/Homepage.vue
// module id = 689
// module chunks = 4